import React, {Fragment} from 'react';
import classnames from 'classnames';
import {Card, CardBody, Col, Row} from 'reactstrap';

export interface TimelineItem {
    tag?: keyof JSX.IntrinsicElements;
    className?: string;
    color?: string;
    icon?: React.ReactNode;
    title: React.ReactNode;
    meta?: React.ReactNode;
    metaClassName?: string;
    content: React.ReactNode;
    customContent?: React.ReactNode;
}

interface TimelineProps {
    data: TimelineItem[];
    className?: string;
    tag?: keyof JSX.IntrinsicElements;
    leftColumnContent?: () => JSX.Element;
}

const Timeline: React.FC<TimelineProps> = ({data, leftColumnContent}) => {
    return (
        <Fragment>
            <Row className={"align-content-center"}>
                {/* Left Column */}
                {leftColumnContent && (
                    <Col lg="4" md="12" className="timeline-left-column">
                        {leftColumnContent()}
                    </Col>
                )}

                {/* Timeline Items (Horizontal Layout) */}
                <Col lg={leftColumnContent ? '8' : '12'} md="12">
                    <Card
                        className={classnames('timeline')}
                    >
                        {data.map((item, i) => {

                            return (
                                <CardBody
                                    key={i}
                                    className={classnames('timeline-item text-center')}
                                >
                                    {/* Timeline Point */}
                                    <Row style={{marginBottom: "10px"}}>
                                        <Col>
                                            <span
                                                className={classnames('timeline-point', {
                                                    [`timeline-point-${item.color}`]: item.color, // Add color class if provided
                                                    'timeline-point-indicator': !item.icon, // Add indicator class if no icon
                                                })}
                                            >
                                        {item.icon}
                                    </span>
                                        </Col>
                                    </Row>

                                    {/* Timeline Event */}
                                    <Row>
                                        <Col>
                                            <h6>{item.title}</h6>
                                            {item.meta && (
                                                <span>{item.meta}</span>
                                            )}
                                            {item.content}
                                            {item.customContent}
                                        </Col>
                                    </Row>
                                    {/* Horizontal Line Connector */}
                                    {i < data.length - 1 && (
                                        <span className="timeline-connector">
                                            {/* Styling handled via CSS */}
                                        </span>
                                    )}
                                </CardBody>
                            );
                        })}
                    </Card>
                </Col>

            </Row>
        </Fragment>
    );
};

export default Timeline;
